import React from "react";

export const GlobalPresence = (props) => {
  const data = props.data || {};
  const {
    headline = "Seven Hubs, One Global Network",
    subhead = "",
    map = "img/map/map.png",
    stats = [],
    hubs = [],
    cloudPartners = [],
    capabilities = [],
    teamTitle = "Built by Cloud and AI Practitioners",
    teamText = "",
  } = data;

  const openPage = (event, slug) => {
    if (!props.onOpenPage) return;
    event.preventDefault();
    props.onOpenPage(slug);
  };

  return (
    <section id="team" className="global-presence">
      <div className="container">
        <div className="gp-head section-title text-center">
          <h2>{headline}</h2>
          {subhead && <p>{subhead}</p>}
          <div className="gp-head-actions">
            <a
              href="#/global-presence"
              className="gp-detail-link gp-detail-link-primary"
              onClick={(event) => openPage(event, "global-presence")}
            >
              Explore Global Network
              <i className="fa fa-arrow-right" />
            </a>
            <a
              href="#/why-goldly"
              className="gp-detail-link"
              onClick={(event) => openPage(event, "why-goldly")}
            >
              Why Goldly AI
            </a>
          </div>
        </div>

        <div className="gp-top">
          <div className="gp-map-wrap">
            <img src={map} alt="Global Presence Map" className="gp-map-img" />
          </div>

          <div className="gp-stats">
            {stats.map((s, i) => (
              <div className="gp-stat-card" key={i}>
                <div className="gp-stat-icon">
                  <i className={s.icon || "fa fa-circle"} />
                </div>
                <div className="gp-stat-body">
                  <div className="gp-stat-value">{s.value}</div>
                  <div className="gp-stat-label">{s.label}</div>
                  {s.sublabel && (
                    <div className="gp-stat-sub">{s.sublabel}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {capabilities.length > 0 && (
          <div className="gp-capability-strip">
            {capabilities.map((capability, index) => (
              <div className="gp-capability-item" key={index}>
                <i className={capability.icon || "fa fa-circle"} />
                <div>
                  <strong>{capability.title}</strong>
                  <span>{capability.text}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="gp-hubs">
          {hubs.map((h, i) => (
            <div className="gp-hub-card" key={i}>
              <div className="gp-hub-icon">
                <i className={h.icon || "fa fa-map-marker"} />
              </div>
              <div className="gp-hub-city">{h.city}</div>
                <div className="gp-hub-role">
                {h.role}
                {h.subrole && (
                  <>
                    <br />
                    {h.subrole}
                  </>
                )}
                </div>
            </div>
          ))}
        </div>

        {cloudPartners.length > 0 && (
          <div className="gp-partners">
            <div className="gp-partners-intro">
              <div className="gp-partners-icon">
                <i className="fa fa-users" />
              </div>
              <div>
                <div className="gp-partners-title">{teamTitle}</div>
                <p className="gp-partners-sub">
                  {teamText ||
                    "Our team members bring together deep expertise and experience from the world's leading cloud and internet companies."}
                </p>
                <a
                  href="#/team-expertise"
                  className="gp-inline-link"
                  onClick={(event) => openPage(event, "team-expertise")}
                >
                  Discover Our Expertise
                  <i className="fa fa-arrow-right" />
                </a>
              </div>
            </div>
            <div className="gp-partners-grid">
              {cloudPartners.map((p, i) => (
                <div className="gp-partner-card" key={i}>
                  {p.logo ? (
                    <img
                      src={p.logo}
                      alt={p.name}
                      className="gp-partner-logo"
                    />
                  ) : (
                    <>
                      <i className={`${p.icon} gp-partner-icon`} />
                      <span className="gp-partner-name">{p.name}</span>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
